<template>
    <v-app :lang="$i18n.locale">
        <NavBar />
        <v-overlay :value="loading">
            <v-sheet justify-center align-center outlined color="transparent">
                <v-progress-circular indeterminate :size="50">
                </v-progress-circular> </v-sheet
        ></v-overlay>
        <FormHeader
            v-if="registrationFormDetail"
            :openingDateProp="registrationFormDetail.opening_date"
            :closingDateProp="registrationFormDetail.closing_date"
        />
        <div v-if="stepId != null">
            <StepOne
                v-if="this.stepId === '1' && registrationFormDetail"
                :registrationFormDetail="registrationFormDetail"
                :student_id="student_id"
                :student_status="student_status"
                @loadingUpdate="loadingProcess"
            />
            <StepTwo
                v-if="this.stepId === '2' && registrationFormDetail"
                :registrationFormDetail="registrationFormDetail"
                :student_id="student_id"
                @loadingUpdate="loadingProcess"
            />
            <StepThree
                v-if="this.stepId === '3' && registrationFormDetail"
                :registrationFormDetail="registrationFormDetail"
                :student_id="student_id"
                :student_status="student_status"
                @loadingUpdate="loadingProcess"
            />
            <StepFour
                v-if="this.stepId === '4' && registrationFormDetail"
                :registrationFormDetail="registrationFormDetail"
                :student_id="student_id"
                :student_status="student_status"
                :result_type="student_result_type"
                @loadingUpdate="loadingProcess"
            />
            <StepFive
                v-if="this.stepId === '5' && registrationFormDetail"
                :registrationFormDetail="registrationFormDetail"
                :student_id="student_id"
                :success="success"
                :result_type="student_result_type"
                :student_status="student_status"
                @loadingUpdate="loadingProcess"
            />
        </div>
    </v-app>
</template>

<script>
import * as services from "@/services";
import StepOne from "@/components/StepOne.vue";
import StepTwo from "@/components/StepTwo.vue";
import StepThree from "@/components/StepThree.vue";
import StepFour from "@/components/StepFour.vue";
import StepFive from "@/components/StepFive.vue";
import NavBar from "@/components/NavBar.vue";
import FormHeader from "@/components/FormHeader.vue";
import router from "@/router";
import { RegistrationStatusEnum, ResultTypeEnum } from "@/constants";
import dayjs from "dayjs";

export default {
    name: "FormPage",
    data: () => ({
        loading: 0,
        stepId: null,
        student_token: null,
        student_id: null,
        student_status: null,
        student_result_type: null,
        registrationFormDetail: {},
        success: false,
    }),
    components: {
        StepOne,
        StepTwo,
        StepThree,
        StepFour,
        StepFive,
        NavBar,
        FormHeader,
    },
    methods: {
        async getResource() {
            try {
                this.stepId = null
                this.loadingProcess(1);
                const {
                    data: { data },
                } = await services.getStudent({
                    token: this.student_token,
                });

                if (data.student.id != null) {
                    this.student_id = data.student.id;
                    this.student_status = data.student.registration_status;
                    this.student_result_type = data.student.result_type;
                    await this.getRegistrationForm();
                }
            } catch (err) {
                this.loading = 0;
                window.location.href = "/error";
            } finally {
                this.loadingProcess(-1);
            }
        },
        async getRegistrationForm() {
            try {
                this.loadingProcess(1);
                const {
                    data: { data },
                } = await services.getRegistrationFormByStudent(
                    this.student_id
                );
                this.registrationFormDetail = data.register_form_config;

                // Before Exam
                if (this.student_result_type == null) {
                    if (this.student_status == null) {
                        // Register Form
                        router.push("1");
                        this.stepId = "1";
                    } else if (
                        this.student_status ==
                        RegistrationStatusEnum.PENDING_PAYMENT
                    ) {
                        // Pending Payment
                        router.push("2");
                        this.stepId = "2";
                    } else if (
                        this.student_status ==
                            RegistrationStatusEnum.REGISTER ||
                        this.student_status ==
                            RegistrationStatusEnum.SUCCESSFUL_PAYMENT ||
                        this.student_status ==
                            RegistrationStatusEnum.EXAM_AUTHORIZE ||
                        this.student_status ==
                            RegistrationStatusEnum.EXAM_UNAUTHORIZE ||
                        this.student_status ==
                            RegistrationStatusEnum.EXAM_AUTHORIZE_BY_SYSTEM
                    ) {
                        // Already payment and wait to exam
                        router.push("3");
                        this.stepId = "3";
                    }
                } else {
                    // Pending Payment
                    router.push("3");
                    this.stepId = "3";

                    // After Exam
                    // if (this.student_result_type == ResultTypeEnum.PASS) {
                    //     // Actual selection

                    //     const announceDate = new Date(
                    //         this.registrationFormDetail
                    //             ?.announcement_exam_result_date + " " + this.registrationFormDetail?.announcement_exam_result_time
                    //     );
                    //     if ( dayjs(announceDate).isSameOrBefore(dayjs(this.registrationFormDetail?.currentDate))) {
                    //         // On announcement date
                    //         if (
                    //             this.student_status ==
                    //             RegistrationStatusEnum.PENDING_CONFIRMATION ||
                    //             this.student_status ==
                    //             RegistrationStatusEnum.REJECTION
                    //         ) {
                    //             // Wait to Submit or Reject to enrollment
                    //             router.push("4");
                    //             this.stepId = "4";
                    //         } else if (
                    //             this.student_status ==
                    //             RegistrationStatusEnum.SUCCESSFUL_CONFIRMATION
                    //         ) {
                    //             // Submit and wait to complete form
                    //             this.stepId = "5";
                    //             this.success = false;
                    //             router.push("5");
                    //         } else if (
                    //             this.student_status ==
                    //                 RegistrationStatusEnum.SUCCESSFUL_CONFIRMATION_DETAIL ||
                    //             this.student_status ==
                    //                 RegistrationStatusEnum.SUCCESSFUL_ENROLLMENT
                    //         ) {
                    //             // Successful enrollment
                    //             this.stepId = "5";
                    //             this.success = true;
                    //             router.push("5");
                    //         }
                    //     } else {
                    //         // Wait to announcement date
                    //         router.push("3");
                    //         this.stepId = "3";
                    //     }
                    // } else if (this.student_result_type == ResultTypeEnum.RESERVED) {
                    //     // Reserved selection
                    //     const reservedDate = new Date(
                    //         this.registrationFormDetail
                    //             ?.reserved_announcement_exam_result_date + " " + this.registrationFormDetail?.reserved_announcement_exam_result_time
                    //     );
                    //     if (dayjs(reservedDate).isSameOrBefore(dayjs(this.registrationFormDetail?.currentDate))) {
                    //         // On announcement date
                    //         if (
                    //             this.student_status ==
                    //                 RegistrationStatusEnum.PENDING_CONFIRMATION ||
                    //             this.student_status ==
                    //                 RegistrationStatusEnum.REJECTION
                    //         ) {
                    //             // Wait to Submit or Reject to enrollment
                    //             router.push("4");
                    //             this.stepId = "4";
                    //         } else if (
                    //             this.student_status ==
                    //             RegistrationStatusEnum.SUCCESSFUL_CONFIRMATION
                    //         ) {
                    //             // Submit and wait to complete form
                    //             router.push("5");
                    //             this.stepId = "5";
                    //             this.success = false;
                    //         } else if (
                    //             this.student_status ==
                    //                 RegistrationStatusEnum.SUCCESSFUL_CONFIRMATION_DETAIL ||
                    //             this.student_status ==
                    //                 RegistrationStatusEnum.SUCCESSFUL_ENROLLMENT
                    //         ) {
                    //             // Successful enrollment
                    //             router.push("5");
                    //             this.stepId = "5";
                    //             this.success = true;
                    //         }
                    //     } else {
                    //         // Wait to announcement date
                    //         router.push("3");
                    //         this.stepId = "3";
                    //     }
                    // } else if (
                    //     this.student_result_type == ResultTypeEnum.FAILED
                    // ) {
                    //     // Failed examination
                    //     if (
                    //         this.student_status ==
                    //         RegistrationStatusEnum.NOT_QUALIFY
                    //     ) {
                    //         // Not qualify student
                    //         router.push("4");
                    //         this.stepId = "4";
                    //     }
                    // }
                }

            }
            finally {
                this.loadingProcess(-1);

            }
        },
        loadingProcess(value) {
            if (value == 0) {
                this.loading = 0;
            }
            this.loading += value;
            if (this.loading < 0) this.loading = 0;
        },
    },
    mounted() {
        this.student_token = localStorage.getItem("token");
        this.getResource();
    },
};
</script>

<style lang=""></style>
